import { Skeleton, Stack } from "@mui/material";
import { FC } from "react";
import { useIsMobile } from "../hooks/useIsMobile";

export const PageSkeleton: FC = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Stack spacing={0} sx={{ pt: { xs: 2, md: 3 } }} width="100%">
        <Skeleton
          sx={{
            width: "min(155px, 100%)",
            height: 24,
            borderRadius: "16px",
            opacity: 1,
            mb: 3,
          }}
          variant="rounded"
        />
        <Skeleton
          sx={{
            width: "100%",
            height: 32,
            borderRadius: "16px",
            opacity: 1,
            mb: 3,
          }}
          variant="rounded"
        />
        <Skeleton
          sx={{
            width: "100%",
            height: 32,
            borderRadius: "16px",
            opacity: 1,
            mb: 6,
          }}
          variant="rounded"
        />
        <Skeleton
          sx={{
            width: "100%",
            height: 256,
            borderRadius: "16px",
            opacity: 1,
            mb: 3,
          }}
          variant="rounded"
        />
      </Stack>
    );
  }

  return (
    <Stack spacing={4} sx={{ pt: { xs: 2, md: 3 } }} width="100%">
      <Skeleton
        sx={{
          width: "min(362px, 100%)",
          height: 40,
          borderRadius: "16px",
          opacity: 1,
        }}
        variant="rounded"
      />
      <Skeleton
        sx={{
          width: "100%",
          height: 32,
          borderRadius: "16px",
          opacity: 1,
        }}
        variant="rounded"
      />
      <Skeleton
        sx={{
          width: "100%",
          height: 400,
          borderRadius: "16px",
          opacity: 1,
        }}
        variant="rounded"
      />
    </Stack>
  );
};
